import styled from "styled-components";

export const CardWitnessStyles = styled.div`
  border-radius: 10px;
  background: #f7f7f7;
  display: grid;
  padding: 16px 8px;
  gap: 24px;
  grid-template-columns: 1fr 0.1fr;
  grid-template-areas: "nome icon" "cargo cargo";

  > p {
    color: #111;
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.42px;

    span {
      font-weight: 400;
    }
  }

  > p:nth-child(1) {
    grid-area: nome;
  }

  > p:nth-child(2) {
    grid-area: cargo;
  }

  > div:nth-child(3) {
    grid-area: icon;

    > img {
      cursor: pointer;
    }
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 0.1fr;
    grid-template-areas: "nome cargo icon";
    align-items: center;
  }
`;
